<template>
    <div class="auth">
        <div class="container">
            <div class="row">
                <router-view></router-view>
            </div>

            <div class="row">
                <div class="col-lg-5 col-md-8 ml-auto mr-auto">
                    <div class="auth__version">
                        <p>{{ version }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                version: process.env.VUE_APP_VERSION,
            }
        }
    }
</script>